import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceRemoveListState = createStateReducer(initialState, {
  [events.removeListSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeList",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeListFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeList",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveListState };
